import { render, staticRenderFns } from "./AboutUsProvider.vue?vue&type=template&id=31b86794"
import script from "./AboutUsProvider.vue?vue&type=script&lang=js"
export * from "./AboutUsProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports